import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { Image, CreateImageResponse, GetAllImageByAutoId, AssetImageViewModel } from './interfaces/upload-image.i';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'iposcen-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  @ViewChild('imageModal') imageModal: ElementRef;
  @Output() readonly setSideNavValue = new EventEmitter();

  deleteTooltipLabel = GlobalConstants.DELETE;
  imageDeleteButton = GlobalConstants.MEDIA;
  imageDeleteName: string;
  imageToDelete: string;
  isImageAvailable: boolean = true;

  autoId: string;
  type: string;
  typeConfiguration: string = OemConstants.IMAGE_SLASH;
  image: AssetImageViewModel[] = [];
  uploadImageSortValue = GlobalConstants.UPLOAD_DATE;
  uploadDateOption = GlobalConstants.UPLOAD_DATE;
  fileNameOption = GlobalConstants.FILE_NAME

  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;
  @ViewChild('ImageDeleteModal') imageDeletePopup: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  deleteImageData: any;
  deleteImageLable: any;
  isDeleteDisable: boolean;
  noImages: boolean;
  imageLabel = $localize`:@@upload-image.header.sing:Image`;
  constructor(private oemservice: OemService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.type = OemConstants.IMAGE;
    this.autoId = this.oemservice.getAutoId();
    this.noImages = false;
    this.getAllImagesByAutoId();
  }
  open(data) {
    this.deleteImageLable = data.fileName;
    this.deleteImageData = data;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.isDeleteDisable = false;
    this.modalRef = this.modalService.open(this.imageDeletePopup, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
    this.deleteImageData = '';

  }

  dismiss() {
    this.modalRef.dismiss();
    this.deleteImageData = '';
  }
  deleteImage() {
    this.oemservice.deleteVideo(this.deleteImageData.assetID)
      .pipe()
      .subscribe(res => {
        this.close();
        this.image = [];
        this.getAllImagesByAutoId();
      }, err => {
        this.isDeleteDisable = true;
      });
  }

  getAllImagesByAutoId() {
    this.oemservice.getAllAssetsByAutoId(this.type)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllImageResponse => {
        const image = [];
        const getImageByAutoId: GetAllImageByAutoId = getAllImageResponse as GetAllImageByAutoId;
        if(getImageByAutoId.assets.length === 0){
          this.noImages = true;
        }else{
          this.noImages = false;
        }
        getImageByAutoId.assets.forEach(assets => {
          const reader = new FileReader();
          const imageViewModel: AssetImageViewModel = assets as AssetImageViewModel;

          this.oemservice.getAssetByAutoIdAndAssetId(assets.assetID, OemConstants.SLASH_IMAGE)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                imageViewModel.imageData = reader.result;
                imageViewModel.fileName = assets.assetName;
                this.image.push(imageViewModel);
                if(this.image.length === 0){
                  this.noImages = false;
                }else{
                  this.noImages= true;
                }
                
                this.image.forEach(ele => {
                  ele.shortFileName = this.getShortFileName(ele.fileName);
                  ele.updatedTime = new Date(ele.updatedTime);
                  ele.updateTimeDisplay = new Date(ele.updatedTime).toLocaleString()
                    .replace(',', '');
                })
                this.sortBy('uploadDate');
              }, false)

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
            },

              error => {
                // do something
              });
        })

      },
        error => {
          // do something
        });

    if (this.image.length > 0) {
      this.isImageAvailable = true;
    } else {
      this.isImageAvailable = false;
    }
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal() {
    this.openModal(this.imageModal)
  }

  deleteThumbnail(abc) {

  }

  goBack() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  goNextTab() {
    this.setSideNavValue.emit('upload_video');
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'uploadDate': {
        this.uploadImageSortValue = GlobalConstants.UPLOAD_DATE;
        this.image.sort((image1, image2) => (image2.updatedTime as any) - (image1.updatedTime as any));
        break;
      }
      case 'fileName': {
        this.uploadImageSortValue = GlobalConstants.FILE_NAME;
        this.image.sort((image1, image2) =>
          image1.assetName.localeCompare(image2.assetName));
        break;
      }
      default:
        break;
    }
  }

  getShortFileName(fileName: string): string {
    let finalName: string;
    var str = fileName;
    var arr = str.split(".");
    var lastVal = arr.pop();
    var firstVal = arr.join(".");

    if (firstVal.length > 12) {
      let flname = firstVal;
      let extension = lastVal;
      flname = firstVal.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  processFile(imageInput) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];

    if (file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }

    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const assets = {
          type: `${this.typeConfiguration}${fileType}`,
          assetName: file.name,
          assetCategory: OemConstants.IMAGE
        };

        this.oemservice.uploadAssets(JSON.stringify(assets))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe()
          .subscribe(createAsset => {
            const createTileThumbnailResponse: CreateImageResponse = createAsset as CreateImageResponse;
            const assetImageViewModel: AssetImageViewModel = createTileThumbnailResponse.assets as AssetImageViewModel;

            //PATCH Endpoint to insert the downloadURL
            this.oemservice.updateDownloadURL(this.autoId, createAsset.assets.assetID, fileType, OemConstants.IMAGE.toLowerCase())
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(res => {

              })

            this.oemservice.uploadImage(file, createAsset.assets.assetID, file.name.split('.').pop(), this.autoId, OemConstants.IMAGE_ASSETS_PATH)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                assetImageViewModel.imageData = event.target.result;
                assetImageViewModel.shortFileName = this.getShortFileName(file.name);;
                assetImageViewModel.fileName = file.name;
                assetImageViewModel.updatedTime = new Date(assetImageViewModel.updatedTime);
                assetImageViewModel.updateTimeDisplay = new Date(assetImageViewModel.updatedTime).toLocaleString()
                  .replace(',', '');
                this.image.push(assetImageViewModel);
                this.sortBy('uploadDate');
              },

                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      });

    }
    reader.readAsDataURL(file);
  }

}
